module.exports = __webpack_public_path__ + "static/img/georgia-flag-256.730f84c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/georgia-flag-256.png
// module id = Vq87
// module chunks = 1